<template>
  <div>
    <MainNavigation v-if="!hasFunnelHeader" />
    <nuxt />
    <QuickQuoteModal />
    <CongratsModal />
    <Footer v-if="!isInPurchaseFunnel && !hasFunnelHeader" />
    <BuildBadge />
  </div>
</template>

<script>
/* eslint-disable no-console */
import MainNavigation from '@/components/MainNavigation'
import QuickQuoteModal from '@/components/modals/QuickQuote'
import Footer from '@/components/common/Footer'
import CongratsModal from '@/components/modals/Congrats'
import BuildBadge from '@/components/common/BuildBadge'
import { isPurchaseFunnelPath } from '@/helpers'
import { hasFunnelHeader } from '@/helpers/quoteSteps'

import { buildSeoHead } from '@/helpers/seo'

export default {
  components: {
    BuildBadge,
    MainNavigation,
    QuickQuoteModal,
    CongratsModal,
    Footer,
  },
  head() {
    return {
      // Canonical (and noindex where the route has no search value) for every
      // page using this layout — see helpers/seo.js.
      ...buildSeoHead(this.$route.path),
      style: [
        { cssText: this.$store.getters['theme/theme'], type: 'text/css' },
      ],
    }
  },
  computed: {
    // Checkout steps drop the footer — its nav is a way back out of the
    // funnel, and the sticky price bar already owns the bottom of the screen.
    isInPurchaseFunnel() {
      return isPurchaseFunnelPath(this.$route.path)
    },
    // Checkout steps render their own slim header (logo, progress, help),
    // so the marketing nav would only stack a second bar on top of it.
    hasFunnelHeader() {
      return hasFunnelHeader(this.$route.path)
    },
  },
  mounted() {
    this.$store.dispatch('quote/setMtaFlag', false)
  },
}
</script>

<style lang="scss" scoped>
.logo {
  font-size: 1.3rem;
  color: $white;
}
</style>
